export const messages = {
  en: {
    dashboard: 'Dashboard',
    helloAdmin: 'Hello, Admin',
    exportOrders: 'Export Orders',
    exporting: 'Exporting...',
    exportDateRange: 'Export Date Range',
    orderReport: 'Order Report',
    monthlyOrderReport: 'Monthly Order Report',
    exportOrdersByDate: 'Export Orders by Date',
    selectedDatesIncluded: 'The selected start and end dates are included.',
    from: 'From',
    to: 'To',
    cancel: 'Cancel',
    exportCsv: 'Export CSV',
    contacts: 'Contacts',
    orders: 'Orders',
    abandonedCheckouts: 'Abandoned Checkouts',
    abandonedCheckoutsDescription: 'Card payments that never completed, and guests who never verified their phone. Contact info only - follow up manually.',
    allReasons: 'All',
    cardPaymentIncomplete: 'Card payment incomplete',
    cardPaymentDeclined: 'Card payment declined',
    cardPaymentTimedOut: 'Card payment - never completed',
    phoneNotVerified: 'Phone not verified',
    recoverySent: 'Recovery Message',
    recoveryFailed: 'Failed',
    orderNumberCol: 'Order Number',
    whatsappConversations: 'WhatsApp Conversations',
    whatsappConversationsDescription: 'What every order-approval message said, and how the customer replied.',
    selectConversation: 'Select a conversation to view the chat',
    noConversations: 'No conversations yet',
    searchConversations: 'Search by phone, order number or name',
    noConversationsFound: 'No conversations match your search',
    typeAReply: 'Type a reply...',
    send: 'Send',
    replyWindowClosed: "This customer's 24-hour reply window has closed - only a template message can reach them now.",
    replyFailed: 'Could not send the message - please try again.',
    attachFile: 'Attach a file',
    addACaptionOptional: 'Add a caption (optional)...',
    downloadFile: 'Download file',
    sending: 'Sending...',
    abandonedCarts: 'Abandoned Carts',
    abandonedCartsDescription: 'A phone number typed into checkout that never became a real order - separate from "Abandoned Checkouts", which tracks card payments and unverified-OTP attempts that got further.',
    notConverted: 'Not converted',
    converted: 'Converted',
    cartValue: 'Cart Value',
    whatsappSent: 'Recovery Sent',
    partiallyDelivered: 'Partially Delivered',
    deliveryType: 'Delivery type',
    pickAndChoose: 'Pick & Choose',
    standardDelivery: 'Standard',
    customerReturnedItems: 'Customer returned these items',
    bostaCatalog: 'Bosta catalog',
    bostaCatalogHelp: 'Register this product (every size) in Bosta so orders with 2-3 items - including different sizes of the same shoe - can go out as Pick & Choose (the customer keeps what they want and returns the rest). Sizes are also registered automatically when the waybill of such an order is created.',
    registeredInBosta: 'Registered in Bosta',
    notRegisteredInBosta: 'Not registered in Bosta',
    registerInBosta: 'Register in Bosta',
    reRegisterInBosta: 'Register again',
    registering: 'Registering...',
    bostaRegisterFailed: 'Could not register the product in Bosta.',
    bdUnchanged: 'unchanged',
    bdOtherChanges: 'Other changes',
    bdReference: 'Reference',
    bdException: 'Exception reason',
    bdPreviewTitle: 'Preview - nothing is saved yet',
    bdRows: 'rows',
    bdWillImport: 'will be imported',
    bdWillUpdate: 'will be updated',
    bdAction: 'Action',
    bdAction_new: 'New',
    bdAction_update: 'Update',
    bdAction_ours: 'Your order',
    bdAction_pending: 'Pending',
    bdAction_no_tracking: 'No tracking',
    bdPreviewFirst: 'Showing {n} of {total} rows that will change (your own orders and unchanged rows are not listed).',
    bdConfirmImport: 'Confirm import',
    bdEmptyFile: 'The file has no rows.',
    bdImport: 'Import Bosta export',
    bdReading: 'Reading file...',
    bdImported: 'Imported',
    bdUpdated: 'Updated',
    bdAlreadyOurs: 'Already your orders',
    bdNoTracking: 'Skipped (no tracking number)',
    bdSkippedPending: 'Skipped (pending in Bosta)',
    bdUnrecognized: 'Columns not recognised',
    bdImportFailed: 'Could not import the file.',
    bostaDeliveries: 'Bosta Deliveries',
    bostaDeliveriesDescription: 'Returns and exchanges created from here, plus anything created directly in Bosta\'s dashboard.',
    bdAll: 'All',
    bdReturns: 'Returns',
    bdExchanges: 'Exchanges',
    bdDeliveries: 'Deliveries',
    bdSearch: 'Search by waybill, order number, name or phone',
    bdType: 'Type',
    bdType_deliver: 'Delivery',
    bdType_cash_collection: 'Cash collection',
    bdType_return_to_origin: 'Return to origin',
    bdType_return: 'Return',
    bdType_exchange: 'Exchange',
    bdType_pick_and_choose: 'Pick & Choose',
    bdType_other: 'Other',
    bdCod: 'Cash to collect',
    bdOrigin: 'Created in',
    bdFromBosta: 'Bosta dashboard',
    bdFromAdmin: 'This admin',
    bdRefresh: 'Refresh status from Bosta',
    bdRefreshFailed: 'Could not refresh from Bosta.',
    bdCreateReturn: 'Create return',
    bdCreateExchange: 'Create exchange',
    bdReturn: 'Return (customer sends it back)',
    bdExchange: 'Exchange (swap for another item)',
    bdItemsComingBack: 'Items coming back from the customer',
    bdNewItems: 'New item(s) being sent to the customer',
    bdNewItemsPlaceholder: 'e.g. Sterling Derby (Black / 44)',
    bdReturnNoCash: 'Bosta does not accept cash collection on a return pickup (only a refund to the customer), so a return is created with no cash. To collect money from the customer, create an exchange instead.',
    bdPickNewItems: 'Pick the new item(s) being sent in the exchange',
    bdPickNewItemsFromList: 'Search the product list and add the new items. The exchange is also created as a new pending order, and these items leave your stock.',
    bdNoNewItemsYet: 'No new items picked yet.',
    bdCodExchangeHelp: 'The amount the courier collects from the customer. It becomes the new order\'s total; the rest of the new items\' price is shown as exchange credit.',
    bdReturnOrderNote: 'The return is also added to Orders with status Out for delivery.',
    followUpOf: 'Follow-up of',
    bdCodToCollect: 'Cash to collect from the customer (EGP)',
    bdCodHelp: 'Bosta cannot pay money to the customer, so this can only be an amount collected from them (0 or more, up to 30,000).',
    bdNotes: 'Notes for the courier',
    bdReturnNotes: 'Notes about the item being returned',
    bdSubmit: 'Create in Bosta',
    bdCreated: 'Created in Bosta.',
    bdCreateFailed: 'Bosta could not create this delivery.',
    bdPickItems: 'Select at least one item that is coming back.',
    bdLoadOrderFailed: 'Could not load the order.',
    warehouseStock: 'Warehouse stock',
    whHelp: 'Upload the warehouse\'s daily Excel sheet exactly as it is. You see every change first; nothing is saved until you press Apply, and the stock of each size is set to the sheet\'s balance.',
    whChooseFile: 'Choose Excel file',
    whWorking: 'Working...',
    whApplied: 'Done - {n} sizes updated.',
    whSheets: 'sheets',
    whMatched: 'matched',
    whNeedsChoice: 'need your choice',
    whUnmatched: 'not in the catalogue',
    whWillChange: 'sizes will change',
    whPickFamily: 'Pick which SKU family each sheet belongs to (asked once, then remembered)',
    whSelect: 'Select...',
    whNoModel: 'Sheets with no matching products (ignored)',
    whSheet: 'Sheet',
    whInSite: 'On the site',
    whInSheet: 'In the sheet',
    whDiff: 'Change',
    whNothingToChange: 'The site already matches the sheet - nothing to change.',
    whMissingSizes: 'In the sheet but not a size on the site (ignored)',
    whApply: 'Apply to stock ({n} sizes)',
    whConfirm: 'Set the stock of {n} sizes to the numbers in the sheet?',
    whNoSheets: 'No warehouse sheets were found in this file.',
    whFailed: 'Could not process the warehouse sheet.',
    orderDiscount: 'Discount',
    orderDiscountHelp: 'An extra discount on this order, from a small amount up to 100% (a free order). It is taken off everything the customer still pays, delivery included.',
    discountPercent: '% of the order',
    discountEgp: 'Amount (EGP)',
    discountFull: '100% (free)',
    discountAmountApplied: 'Discount',
    customerPays: 'Customer pays',
    discountLockedFollowUp: 'The amount to collect on an exchange/return order was fixed when it was created.',
    discountLockedPaid: 'This order was already paid by card, so its total cannot be changed here.',
    deliveredOrders: 'Delivered Orders',
    deliveredOrdersDescription: 'Orders delivered in a date range: what Bosta confirmed, versus orders marked delivered by hand that Bosta cannot back up.',
    doBostaFees: 'Bosta fees',
    doBostaFeesHint: 'Shipping and fees Bosta kept on these deliveries',
    doFeesUnknown: '{n} order(s) not settled by Bosta yet - fees known for {known}',
    doNetAfterFees: 'Net after Bosta fees',
    doNetAfterFeesHint: 'Net delivered minus Bosta fees',
    doBostaFee: 'Bosta fee',
    doReturnedNone: 'Returns are read from Bosta Deliveries (type Return) - import your Bosta export there first.',
    doReturned: 'Customer returns',
    doReturnedHint: 'Returned by customers (Bosta return), in this period',
    doNet: 'Net delivered',
    doNetHint: 'All delivered minus customer returns',
    doUnpriced: '{n} return(s) not priced - no linked order',
    doReturnValue: 'Return value',
    doNotPriced: 'Not priced',
    doEstimate: 'full order',
    doReturnedAt: 'Returned at',
    doCaseReturn: 'Customer return',
    doExport: 'Export to Excel',
    doExporting: 'Exporting...',
    doExportFailed: 'Could not export the report.',
    doExportTruncated: 'The range has more than 5,000 orders - only the first 5,000 were exported. Narrow the dates.',
    doCase: 'Case',
    doPaymentMethod: 'Payment',
    doOrderStatus: 'Order status',
    doBostaDeliveredAt: 'Delivered per Bosta',
    doMarkedDeliveredAt: 'Marked delivered at',
    doCurrency: 'EGP',
    doFrom: 'From',
    doTo: 'To',
    doApply: 'Apply',
    doAllDelivered: 'All delivered',
    doAllDeliveredHint: 'Every order marked delivered',
    doBostaDelivered: 'Delivered by Bosta',
    doBostaDeliveredHint: 'Bosta status is delivered',
    doManualNoWaybill: 'Marked delivered, no waybill',
    doManualNoWaybillHint: 'Set by hand, never sent through Bosta',
    doManualWaybillNotDelivered: 'Marked delivered, Bosta disagrees',
    doManualWaybillNotDeliveredHint: 'Has a waybill but Bosta status is not delivered',
    doCustomer: 'Customer',
    doTracking: 'Waybill',
    doNoWaybill: 'No waybill',
    doBostaStatus: 'Bosta status',
    doDeliveredAt: 'Delivered at',
    doViewOrder: 'View order',
    blockedContacts: 'Blocked Contacts',
    blockedContactsDescription: 'Phone numbers and IP addresses banned from checkout and OTP verification.',
    type: 'Type',
    value: 'Value',
    ipAddress: 'IP Address',
    reasonOptional: 'Reason (optional)',
    blockContact: 'Block',
    blocking: 'Blocking...',
    blockFailed: 'Could not block this contact - please try again.',
    blockedBy: 'Blocked By',
    resendRecoveryMessage: 'Resend recovery message',
    recoveryMessageSent: 'Recovery message sent.',
    recoveryMessageFailed: 'Could not send the recovery message.',
    reason: 'Reason',
    phone: 'Phone',
    total: 'Total',
    items: 'Items',
    products: 'Products',
    totalOrders: 'Total orders',
    orderValue: 'Order value',
    deliveredRevenue: 'Delivered revenue',
    averageOrderValue: 'Average order value',
    payouts: 'Payouts',
    payoutsDesc: 'Amounts Bosta has confirmed for your delivered orders.',
    settledAmount: 'Settled amount',
    pendingPayout: 'Pending payout',
    allTimeOrderActivity: 'All-time order activity and financial performance.',
    ordersThisMonth: 'Orders this month',
    todaysPerformance: 'Today’s performance',
    todaysOrderActivity: 'A live view of today’s order activity',
    ordersPlaced: 'Orders placed',
    delivered: 'Delivered',
    lowStockAlerts: 'Low-stock alerts',
    itemsWithUnitsOrFewer: 'Items with {count} units or fewer',
    left: 'left',
    allProductsAboveAlert: 'All active products are above the alert level.',
    viewInventory: 'View inventory',
    quickActions: 'Quick Actions',
    newProduct: 'New Product',
    viewMessages: 'View Messages',
    noSku: 'No SKU',
    size: 'Size',
    pending: 'Pending',
    processing: 'Processing',
    approved: 'Approved',
    approvedCustomer: 'Approved - Customer',
    approvedStock: 'Approved - Stock',
    needsManufacture: 'Needs Manufacturing',
    print: 'Print',
    printCourier: 'Print - Courier',
    readyToDeliver: 'Ready to Deliver',
    waitingForShippingCompany: 'Waiting for Shipping Company',
    outForDelivery: 'Out for Delivery',
    outForDeliveryCourier: 'Out for Delivery - Courier',
    shipped: 'Shipped',
    cancelled: 'Cancelled',
    returned: 'Returned',
    scanBarcode: 'Scan Barcode',
    printBostaWaybill: 'Print Bosta Waybill ({count})',
    fetchingWaybill: 'Fetching...',
    printSelected: 'Print Selected ({count})',
    generatingPdf: 'Generating...',
    createOrder: 'Create Order',
    customerInformation: 'Customer Information',
    customerName: 'Customer Name',
    phoneNumber: 'Phone Number',
    addressLine: 'Address',
    city: 'City',
    district: 'District',
    selectCity: 'Select a city',
    selectDistrict: 'Select a district',
    searchProductsPlaceholder: 'Search products by name or SKU...',
    searchProducts: 'Search Products',
    searching: 'Searching...',
    noProductsFound: 'No products found.',
    add: 'Add',
    outOfStock: 'Out of stock',
    inStock: '{count} in stock',
    selectedItems: 'Selected Items',
    noItemsSelectedYet: 'No items added yet - search above to add products.',
    unitPrice: 'Unit Price',
    lineTotal: 'Line Total',
    orderItemsDescription: 'Add, remove, or change the products on this order.',
    waybillWillRegenerate: 'This order already has a Bosta waybill - saving these changes will cancel it and create a brand new one.',
    removeItem: 'Remove',
    discountAmount: 'Discount Amount',
    orderSummary: 'Order Summary',
    estimatedShipping: 'Estimated Shipping',
    removeShippingPrice: 'Remove shipping price for this order',
    estimatedTotal: 'Estimated Total',
    cashOnDeliveryOnly: 'Cash on Delivery (only option for orders created here)',
    placeOrder: 'Place Order',
    placingOrder: 'Placing order...',
    orderCreatedSuccessfully: 'Order created successfully.',
    testimonials: 'Testimonials',
    blogs: 'Blogs',
    categories: 'Categories',
    subCategories: 'Sub Categories',
    productsManagement: 'Products Management',
    featuredSets: 'Featured Sets',
    collections: 'Collections',
    promoCodes: 'Promo Codes',
    fitProfiles: 'Fit Profiles',
    optionTypes: 'Option Types',
    needsManufacturing: 'Needs Manufacturing',
    inventory: 'Inventory',
    soles: 'Soles',
    websiteContent: 'Website Content',
    banners: 'Banners',
    staticPages: 'Static Pages',
    trashRestore: 'Trash / Restore',
    locations: 'Locations',
    countries: 'Countries',
    cities: 'Cities',
    districts: 'Districts',
    email: 'Email',
    sendEmail: 'Send Email',
    subscribers: 'Subscribers',
    logout: 'Logout',
    pages: 'Pages',
    ordersExported: 'Orders exported successfully.',
    ordersExportFailed: 'Failed to export orders. Please try again.',
    selectBothDates: 'Select both dates before exporting.',
    invalidDateRange: 'The end date must be on or after the start date.',
    searchButton: 'Search', clearSearch: 'Clear', search: 'Search...', actions: 'Actions', confirm: 'Confirm', deleteConfirmation: 'Are you sure you want to delete this record?', yes: 'Yes', no: 'No', on: 'on', off: 'off', allStatuses: 'All statuses', view: 'View',
    createProduct: 'Create Product', id: 'ID', name: 'Name', showOnHomepage: 'Show on Homepage', bestSeller: 'Best Seller', defaultPrice: 'Default Price (EGY)', discountedPrice: 'Discounted Price (EGY)', quantity: 'Quantity', category: 'Category', subCategory: 'Sub-Category', hasVariant: 'Has Variant?', image: 'Image', yesValue: 'Yes', noValue: 'No', notAvailable: 'N/A', checkViewPage: 'Check the view page',
    backToOrders: 'Back to Orders', orderDetails: 'Order details', order: 'Order', placed: 'Placed', saving: 'Saving...', update: 'Update', approveAsCod: 'Approve as COD', editOrder: 'Edit Order', grandTotal: 'Grand total', orderItems: 'Order items', noOrderItems: 'No items found for this order.', itemTotal: 'Item total', paymentSummary: 'Payment summary', subtotal: 'Subtotal', discount: 'Discount', cardPaymentDiscount: 'Card payment discount', active: 'active', removedPaymentFailed: 'removed - payment failed', shipping: 'Shipping', customer: 'Customer', guestCustomer: 'Guest customer', customerNumber: 'Customer #{number}', noEmail: 'No email provided', noPhone: 'No phone provided', shippingAddress: 'Shipping address', addressNotProvided: 'Address not provided', noShippingAddress: 'No shipping address provided.', orderInformation: 'Order information', couponCode: 'Coupon code', none: 'None', paymentStatus: 'Payment status', trackingNumber: 'Tracking number', notAssigned: 'Not assigned', transactionId: 'Transaction ID', campaignAttribution: 'Campaign attribution', source: 'Source', medium: 'Medium', campaign: 'Campaign', bostaShipment: 'Bosta shipment', carrier: 'Carrier', shipmentStatus: 'Shipment status', notAssignedYet: 'Not assigned yet', deliveredAt: 'Delivered at', payout: 'Payout', payoutTransaction: 'Payout transaction', bostaShipmentError: 'Bosta rejected this shipment', failed: 'Failed', manualReview: 'Needs manual review', sku: 'SKU',
    orderNumber: 'Order #', dateCreated: 'Date created', shippingPrice: 'Shipping price', totalPrice: 'Total price', currency: 'Currency', paymentMethod: 'Payment method', status: 'Status', waybillNumber: 'Waybill #', searchOrders: 'Search name, phone, or Bosta waybill...',
    reportingPeriod: 'Reporting period', apply: 'Apply', bestSellers: 'Best sellers', unitsSold: 'units sold', orderStatusBreakdown: 'Order status breakdown', ordersInPeriod: 'order(s) in {period}.', approvedValue: 'Approved value', outForDeliveryValue: 'Out for delivery value', noSalesInPeriod: 'No delivered product sales in this date range.', noOrdersInPeriod: 'No orders were created in this date range.', loadingReport: 'Loading report…', invalidReportDates: 'The start date must be before or equal to the end date.', unableToLoadReport: 'Unable to load this order report.',
    rankedBestSellers: 'Ranked by units sold from delivered orders in {period}.', allOrdersInPeriod: 'All orders created in {period}.',
  },
  ar: {
    dashboard: 'لوحة التحكم',
    helloAdmin: 'مرحباً، مدير النظام',
    exportOrders: 'تصدير الطلبات',
    exporting: 'جارٍ التصدير...',
    exportDateRange: 'تصدير نطاق زمني',
    orderReport: 'تقرير الطلبات',
    monthlyOrderReport: 'تقرير الطلبات الشهري',
    exportOrdersByDate: 'تصدير الطلبات حسب التاريخ',
    selectedDatesIncluded: 'سيتم تضمين تاريخَي البداية والنهاية المحددين.',
    from: 'من',
    to: 'إلى',
    cancel: 'إلغاء',
    exportCsv: 'تصدير CSV',
    contacts: 'جهات الاتصال',
    orders: 'الطلبات',
    abandonedCheckouts: 'السلات المتروكة',
    abandonedCheckoutsDescription: 'مدفوعات بالبطاقة لم تكتمل، وعملاء لم يتحققوا من رقم هاتفهم. بيانات التواصل فقط - المتابعة يدويًا.',
    allReasons: 'الكل',
    cardPaymentIncomplete: 'دفع بالبطاقة غير مكتمل',
    cardPaymentDeclined: 'تم رفض الدفع بالبطاقة',
    cardPaymentTimedOut: 'دفع بالبطاقة - لم يكتمل',
    phoneNotVerified: 'لم يتم التحقق من الهاتف',
    recoverySent: 'رسالة المتابعة',
    recoveryFailed: 'فشلت',
    orderNumberCol: 'رقم الطلب',
    whatsappConversations: 'محادثات واتساب',
    whatsappConversationsDescription: 'ما قيل في رسالة تأكيد كل طلب، وكيف رد العميل.',
    selectConversation: 'اختر محادثة لعرضها',
    noConversations: 'لا توجد محادثات بعد',
    searchConversations: 'ابحث برقم الهاتف أو رقم الطلب أو الاسم',
    noConversationsFound: 'لا توجد محادثات مطابقة للبحث',
    typeAReply: 'اكتب ردًا...',
    send: 'إرسال',
    replyWindowClosed: 'انتهت مدة الـ24 ساعة المسموح بها للرد على هذا العميل - لا يمكن الوصول إليه الآن إلا برسالة قالب معتمدة.',
    replyFailed: 'تعذر إرسال الرسالة - يرجى المحاولة مرة أخرى.',
    attachFile: 'إرفاق ملف',
    addACaptionOptional: 'أضف وصفًا (اختياري)...',
    downloadFile: 'تحميل الملف',
    sending: 'جارٍ الإرسال...',
    abandonedCarts: 'السلات المهجورة',
    abandonedCartsDescription: 'رقم هاتف تم إدخاله أثناء الدفع ولم يتحول إلى طلب حقيقي - منفصلة عن "السلات المتروكة" التي تتابع مدفوعات البطاقة ومحاولات عدم التحقق من الهاتف التي وصلت لمرحلة أبعد.',
    notConverted: 'لم يكتمل',
    converted: 'اكتمل',
    cartValue: 'قيمة السلة',
    whatsappSent: 'تم إرسال التذكير',
    partiallyDelivered: 'مسلّم جزئيًا',
    deliveryType: 'نوع التوصيل',
    pickAndChoose: 'اختر وأرجع (Pick & Choose)',
    standardDelivery: 'عادي',
    customerReturnedItems: 'أرجع العميل هذه المنتجات',
    bostaCatalog: 'كتالوج بوسطة',
    bostaCatalogHelp: 'سجّل هذا المنتج (بكل مقاساته) في بوسطة ليتم شحن الطلبات التي تحتوي على 2-3 قطع - حتى لو مقاسات مختلفة من نفس الحذاء - بنظام Pick & Choose (يحتفظ العميل بما يريد ويُرجع الباقي). كما تُسجَّل المقاسات تلقائيًا عند إنشاء بوليصة مثل هذا الطلب.',
    registeredInBosta: 'مسجّل في بوسطة',
    notRegisteredInBosta: 'غير مسجّل في بوسطة',
    registerInBosta: 'تسجيل في بوسطة',
    reRegisterInBosta: 'إعادة التسجيل',
    registering: 'جارٍ التسجيل...',
    bostaRegisterFailed: 'تعذر تسجيل المنتج في بوسطة.',
    bdUnchanged: 'بدون تغيير',
    bdOtherChanges: 'تغييرات أخرى',
    bdReference: 'المرجع',
    bdException: 'سبب الاستثناء',
    bdPreviewTitle: 'معاينة - لم يتم حفظ شيء بعد',
    bdRows: 'صف',
    bdWillImport: 'سيتم استيرادها',
    bdWillUpdate: 'سيتم تحديثها',
    bdAction: 'الإجراء',
    bdAction_new: 'جديد',
    bdAction_update: 'تحديث',
    bdAction_ours: 'طلبك',
    bdAction_pending: 'قيد الانتظار',
    bdAction_no_tracking: 'بدون تتبع',
    bdPreviewFirst: 'عرض {n} من {total} صف سيتغير (طلباتك الحالية والصفوف دون تغيير غير معروضة).',
    bdConfirmImport: 'تأكيد الاستيراد',
    bdEmptyFile: 'الملف لا يحتوي على صفوف.',
    bdImport: 'استيراد ملف بوسطة',
    bdReading: 'جارٍ قراءة الملف...',
    bdImported: 'تم استيراده',
    bdUpdated: 'تم تحديثه',
    bdAlreadyOurs: 'طلباتك الحالية',
    bdNoTracking: 'تم تخطيه (بدون رقم تتبع)',
    bdSkippedPending: 'تم تخطيه (قيد الانتظار في بوسطة)',
    bdUnrecognized: 'أعمدة غير معروفة',
    bdImportFailed: 'تعذر استيراد الملف.',
    bostaDeliveries: 'شحنات بوسطة',
    bostaDeliveriesDescription: 'المرتجعات والاستبدالات المنشأة من هنا، بالإضافة إلى أي شيء تم إنشاؤه مباشرة في لوحة بوسطة.',
    bdAll: 'الكل',
    bdReturns: 'المرتجعات',
    bdExchanges: 'الاستبدالات',
    bdDeliveries: 'التوصيلات',
    bdSearch: 'ابحث برقم البوليصة أو رقم الطلب أو الاسم أو الهاتف',
    bdType: 'النوع',
    bdType_deliver: 'توصيل',
    bdType_cash_collection: 'تحصيل نقدي',
    bdType_return_to_origin: 'مرتجع للمصدر',
    bdType_return: 'مرتجع',
    bdType_exchange: 'استبدال',
    bdType_pick_and_choose: 'اختر وأرجع',
    bdType_other: 'آخر',
    bdCod: 'المبلغ المطلوب تحصيله',
    bdOrigin: 'أُنشئ في',
    bdFromBosta: 'لوحة بوسطة',
    bdFromAdmin: 'لوحة التحكم هذه',
    bdRefresh: 'تحديث الحالة من بوسطة',
    bdRefreshFailed: 'تعذر التحديث من بوسطة.',
    bdCreateReturn: 'إنشاء مرتجع',
    bdCreateExchange: 'إنشاء استبدال',
    bdReturn: 'مرتجع (يعيده العميل)',
    bdExchange: 'استبدال (بمنتج آخر)',
    bdItemsComingBack: 'المنتجات العائدة من العميل',
    bdNewItems: 'المنتج/المنتجات الجديدة المرسلة للعميل',
    bdNewItemsPlaceholder: 'مثال: Sterling Derby (Black / 44)',
    bdReturnNoCash: 'لا تقبل بوسطة تحصيل نقدي على استلام المرتجع (تقبل فقط رد مبلغ للعميل)، لذا يُنشأ المرتجع بدون تحصيل. لتحصيل مبلغ من العميل أنشئ استبدالًا بدلًا من ذلك.',
    bdPickNewItems: 'اختر المنتج/المنتجات الجديدة المرسلة في الاستبدال',
    bdPickNewItemsFromList: 'ابحث في قائمة المنتجات وأضف المنتجات الجديدة. يُنشأ الاستبدال أيضًا كطلب جديد (قيد الانتظار) وتخرج هذه المنتجات من المخزون.',
    bdNoNewItemsYet: 'لم يتم اختيار منتجات جديدة بعد.',
    bdCodExchangeHelp: 'المبلغ الذي يحصّله المندوب من العميل. يصبح إجمالي الطلب الجديد، والباقي من سعر المنتجات الجديدة يظهر كرصيد استبدال.',
    bdReturnOrderNote: 'يُضاف المرتجع أيضًا إلى الطلبات بحالة خارج للتسليم.',
    followUpOf: 'متابعة للطلب',
    bdCodToCollect: 'المبلغ المطلوب تحصيله من العميل (جنيه)',
    bdCodHelp: 'لا تسمح بوسطة بدفع أموال للعميل، لذا يمكن أن يكون هذا مبلغًا يُحصَّل منه فقط (0 أو أكثر، حتى 30,000).',
    bdNotes: 'ملاحظات للمندوب',
    bdReturnNotes: 'ملاحظات عن المنتج المرتجع',
    bdSubmit: 'إنشاء في بوسطة',
    bdCreated: 'تم الإنشاء في بوسطة.',
    bdCreateFailed: 'تعذر على بوسطة إنشاء هذه الشحنة.',
    bdPickItems: 'اختر منتجًا واحدًا على الأقل عائدًا من العميل.',
    bdLoadOrderFailed: 'تعذر تحميل الطلب.',
    warehouseStock: 'مخزن الأونلاين',
    whHelp: 'ارفع ملف إكسل المخزن اليومي كما هو. ستشاهد كل تغيير أولًا، ولا يُحفظ شيء حتى تضغط تطبيق، ويُضبط مخزون كل مقاس على رصيد الملف.',
    whChooseFile: 'اختر ملف إكسل',
    whWorking: 'جارٍ العمل...',
    whApplied: 'تم - تم تحديث {n} مقاسًا.',
    whSheets: 'ورقة',
    whMatched: 'مطابقة',
    whNeedsChoice: 'تحتاج اختيارك',
    whUnmatched: 'غير موجودة في الكتالوج',
    whWillChange: 'مقاس سيتغير',
    whPickFamily: 'اختر عائلة الـ SKU لكل ورقة (تُسأل مرة واحدة ثم تُحفظ)',
    whSelect: 'اختر...',
    whNoModel: 'أوراق بلا منتجات مطابقة (تم تجاهلها)',
    whSheet: 'الورقة',
    whInSite: 'في الموقع',
    whInSheet: 'في الملف',
    whDiff: 'التغيير',
    whNothingToChange: 'الموقع يطابق الملف بالفعل - لا يوجد ما يتغير.',
    whMissingSizes: 'موجودة في الملف وليست مقاسًا في الموقع (تم تجاهلها)',
    whApply: 'تطبيق على المخزون ({n} مقاسًا)',
    whConfirm: 'ضبط مخزون {n} مقاسًا على الأرقام الموجودة في الملف؟',
    whNoSheets: 'لم يتم العثور على أوراق مخزن في هذا الملف.',
    whFailed: 'تعذرت معالجة ملف المخزن.',
    orderDiscount: 'الخصم',
    orderDiscountHelp: 'خصم إضافي على هذا الطلب، من مبلغ صغير حتى 100% (طلب مجاني). يُخصم من كل ما سيدفعه العميل بما فيه الشحن.',
    discountPercent: '% من الطلب',
    discountEgp: 'مبلغ (جنيه)',
    discountFull: '100% (مجاني)',
    discountAmountApplied: 'الخصم',
    customerPays: 'يدفع العميل',
    discountLockedFollowUp: 'المبلغ المطلوب تحصيله في طلب الاستبدال/المرتجع تحدد عند إنشائه.',
    discountLockedPaid: 'هذا الطلب مدفوع بالفعل بالبطاقة، لذا لا يمكن تغيير إجماليه من هنا.',
    deliveredOrders: 'الطلبات المسلّمة',
    deliveredOrdersDescription: 'الطلبات المسلّمة في فترة زمنية: ما أكدته بوسطة، مقابل الطلبات التي تم تحديدها كمسلّمة يدويًا ولا تؤكدها بوسطة.',
    doBostaFees: 'رسوم بوسطة',
    doBostaFeesHint: 'الشحن والرسوم التي خصمتها بوسطة على هذه الطلبات',
    doFeesUnknown: '{n} طلب لم تسوّه بوسطة بعد - الرسوم معروفة لـ {known}',
    doNetAfterFees: 'الصافي بعد رسوم بوسطة',
    doNetAfterFeesHint: 'صافي المسلّم ناقص رسوم بوسطة',
    doBostaFee: 'رسوم بوسطة',
    doReturnedNone: 'تُقرأ المرتجعات من شحنات بوسطة (نوع مرتجع) - استورد ملف بوسطة هناك أولًا.',
    doReturned: 'مرتجعات العملاء',
    doReturnedHint: 'أعادها العملاء (مرتجع بوسطة) في هذه الفترة',
    doNet: 'صافي المسلّم',
    doNetHint: 'كل المسلّم ناقص مرتجعات العملاء',
    doUnpriced: '{n} مرتجع بدون سعر - لا يوجد طلب مرتبط',
    doReturnValue: 'قيمة المرتجع',
    doNotPriced: 'بدون سعر',
    doEstimate: 'الطلب كاملًا',
    doReturnedAt: 'تاريخ الإرجاع',
    doCaseReturn: 'مرتجع عميل',
    doExport: 'تصدير إلى Excel',
    doExporting: 'جارٍ التصدير...',
    doExportFailed: 'تعذر تصدير التقرير.',
    doExportTruncated: 'الفترة تحتوي على أكثر من 5000 طلب - تم تصدير أول 5000 فقط. قلّل نطاق التواريخ.',
    doCase: 'الحالة',
    doPaymentMethod: 'الدفع',
    doOrderStatus: 'حالة الطلب',
    doBostaDeliveredAt: 'التسليم حسب بوسطة',
    doMarkedDeliveredAt: 'تاريخ تحديده كمسلّم',
    doCurrency: 'ج.م',
    doFrom: 'من',
    doTo: 'إلى',
    doApply: 'تطبيق',
    doAllDelivered: 'كل المسلّم',
    doAllDeliveredHint: 'كل طلب تم تحديده كمسلّم',
    doBostaDelivered: 'مسلّم عبر بوسطة',
    doBostaDeliveredHint: 'حالة بوسطة مسلّم',
    doManualNoWaybill: 'مسلّم يدويًا بدون بوليصة',
    doManualNoWaybillHint: 'تم تحديده يدويًا ولم يُشحن عبر بوسطة',
    doManualWaybillNotDelivered: 'مسلّم يدويًا وبوسطة تخالف',
    doManualWaybillNotDeliveredHint: 'له بوليصة لكن حالة بوسطة ليست مسلّم',
    doCustomer: 'العميل',
    doTracking: 'البوليصة',
    doNoWaybill: 'بدون بوليصة',
    doBostaStatus: 'حالة بوسطة',
    doDeliveredAt: 'تاريخ التسليم',
    doViewOrder: 'عرض الطلب',
    blockedContacts: 'جهات الاتصال المحظورة',
    blockedContactsDescription: 'أرقام الهواتف وعناوين IP المحظورة من إتمام الطلب والتحقق عبر OTP.',
    type: 'النوع',
    value: 'القيمة',
    ipAddress: 'عنوان IP',
    reasonOptional: 'السبب (اختياري)',
    blockContact: 'حظر',
    blocking: 'جارٍ الحظر...',
    blockFailed: 'تعذر حظر جهة الاتصال - يرجى المحاولة مرة أخرى.',
    blockedBy: 'تم الحظر بواسطة',
    resendRecoveryMessage: 'إعادة إرسال رسالة المتابعة',
    recoveryMessageSent: 'تم إرسال رسالة المتابعة.',
    recoveryMessageFailed: 'تعذر إرسال رسالة المتابعة.',
    reason: 'السبب',
    phone: 'الهاتف',
    total: 'الإجمالي',
    items: 'العناصر',
    products: 'المنتجات',
    totalOrders: 'إجمالي الطلبات',
    orderValue: 'قيمة الطلبات',
    deliveredRevenue: 'إيرادات الطلبات المسلّمة',
    averageOrderValue: 'متوسط قيمة الطلب',
    payouts: 'المستحقات المالية',
    payoutsDesc: 'المبالغ التي أكدتها بوسطة لطلباتك المُسلَّمة.',
    settledAmount: 'المبلغ المُحصَّل',
    pendingPayout: 'المبلغ المعلّق',
    allTimeOrderActivity: 'نشاط الطلبات والأداء المالي منذ البداية.',
    ordersThisMonth: 'طلبات هذا الشهر',
    todaysPerformance: 'أداء اليوم',
    todaysOrderActivity: 'عرض مباشر لنشاط طلبات اليوم',
    ordersPlaced: 'الطلبات المُنشأة',
    delivered: 'تم التسليم',
    lowStockAlerts: 'تنبيهات انخفاض المخزون',
    itemsWithUnitsOrFewer: 'المنتجات التي تحتوي على {count} وحدات أو أقل',
    left: 'متبقي',
    allProductsAboveAlert: 'جميع المنتجات النشطة أعلى من حد التنبيه.',
    viewInventory: 'عرض المخزون',
    quickActions: 'إجراءات سريعة',
    newProduct: 'منتج جديد',
    viewMessages: 'عرض الرسائل',
    noSku: 'لا يوجد رمز SKU',
    size: 'المقاس',
    pending: 'قيد الانتظار',
    processing: 'قيد المعالجة',
    approved: 'تمت الموافقة',
    approvedCustomer: 'تمت الموافقة - العميل',
    approvedStock: 'تمت الموافقة - المخزون',
    needsManufacture: 'بحاجة إلى تصنيع',
    print: 'طباعة',
    printCourier: 'طباعة - المندوب',
    readyToDeliver: 'جاهز للتسليم',
    waitingForShippingCompany: 'في انتظار شركة الشحن',
    outForDelivery: 'خرج للتسليم',
    outForDeliveryCourier: 'خرج للتسليم - المندوب',
    shipped: 'تم الشحن',
    scanBarcode: 'مسح الرمز الشريطي',
    printBostaWaybill: 'طباعة بوليصة بوسطة ({count})',
    fetchingWaybill: 'جارٍ الجلب...',
    printSelected: 'طباعة المحدد ({count})',
    generatingPdf: 'جارٍ الإنشاء...',
    createOrder: 'إنشاء طلب',
    customerInformation: 'معلومات العميل',
    customerName: 'اسم العميل',
    phoneNumber: 'رقم الهاتف',
    addressLine: 'العنوان',
    city: 'المدينة',
    district: 'المنطقة',
    selectCity: 'اختر مدينة',
    selectDistrict: 'اختر منطقة',
    searchProductsPlaceholder: 'البحث عن المنتجات بالاسم أو رمز SKU...',
    searchProducts: 'البحث عن المنتجات',
    searching: 'جارٍ البحث...',
    noProductsFound: 'لم يتم العثور على منتجات.',
    add: 'إضافة',
    outOfStock: 'غير متوفر',
    inStock: '{count} متوفر',
    selectedItems: 'العناصر المحددة',
    noItemsSelectedYet: 'لم تتم إضافة عناصر بعد - استخدم البحث أعلاه لإضافة منتجات.',
    unitPrice: 'سعر الوحدة',
    lineTotal: 'إجمالي السطر',
    orderItemsDescription: 'إضافة أو إزالة أو تغيير المنتجات في هذا الطلب.',
    waybillWillRegenerate: 'هذا الطلب لديه بالفعل بوليصة شحن بوسطة - حفظ هذه التغييرات سيؤدي إلى إلغائها وإنشاء بوليصة جديدة بالكامل.',
    removeItem: 'إزالة',
    discountAmount: 'قيمة الخصم',
    orderSummary: 'ملخص الطلب',
    estimatedShipping: 'الشحن المقدر',
    removeShippingPrice: 'إزالة سعر الشحن لهذا الطلب',
    estimatedTotal: 'الإجمالي المقدر',
    cashOnDeliveryOnly: 'الدفع عند الاستلام (الخيار الوحيد للطلبات المُنشأة هنا)',
    placeOrder: 'تأكيد الطلب',
    placingOrder: 'جارٍ تأكيد الطلب...',
    orderCreatedSuccessfully: 'تم إنشاء الطلب بنجاح.',
    cancelled: 'ملغى',
    returned: 'مرتجع',
    testimonials: 'آراء العملاء',
    blogs: 'المدونة',
    categories: 'التصنيفات',
    subCategories: 'التصنيفات الفرعية',
    productsManagement: 'إدارة المنتجات',
    featuredSets: 'المجموعات المميزة',
    collections: 'المجموعات',
    promoCodes: 'رموز الخصم',
    fitProfiles: 'ملفات القياس',
    optionTypes: 'أنواع الخيارات',
    needsManufacturing: 'يحتاج إلى تصنيع',
    inventory: 'المخزون',
    soles: 'النعال',
    websiteContent: 'محتوى الموقع',
    banners: 'البنرات',
    staticPages: 'الصفحات الثابتة',
    trashRestore: 'سلة المحذوفات / الاستعادة',
    locations: 'المواقع',
    countries: 'الدول',
    cities: 'المدن',
    districts: 'المناطق',
    email: 'البريد الإلكتروني',
    sendEmail: 'إرسال بريد إلكتروني',
    subscribers: 'المشتركون',
    logout: 'تسجيل الخروج',
    pages: 'الصفحات',
    ordersExported: 'تم تصدير الطلبات بنجاح.',
    ordersExportFailed: 'تعذر تصدير الطلبات. حاول مرة أخرى.',
    selectBothDates: 'اختر تاريخَي البداية والنهاية قبل التصدير.',
    invalidDateRange: 'يجب أن يكون تاريخ النهاية في تاريخ البداية أو بعده.',
    searchButton: 'بحث', clearSearch: 'مسح', search: 'بحث...', actions: 'الإجراءات', confirm: 'تأكيد', deleteConfirmation: 'هل أنت متأكد من حذف هذا السجل؟', yes: 'نعم', no: 'لا', on: 'مفعّل', off: 'غير مفعّل', allStatuses: 'كل الحالات', view: 'عرض',
    createProduct: 'إضافة منتج', id: 'المعرّف', name: 'الاسم', showOnHomepage: 'عرض في الصفحة الرئيسية', bestSeller: 'الأكثر مبيعاً', defaultPrice: 'السعر الأساسي (ج.م)', discountedPrice: 'السعر بعد الخصم (ج.م)', quantity: 'الكمية', category: 'التصنيف', subCategory: 'التصنيف الفرعي', hasVariant: 'له خيارات؟', image: 'الصورة', yesValue: 'نعم', noValue: 'لا', notAvailable: 'غير متاح', checkViewPage: 'تحقق من صفحة العرض',
    backToOrders: 'العودة إلى الطلبات', orderDetails: 'تفاصيل الطلب', order: 'طلب', placed: 'تم الإنشاء', saving: 'جارٍ الحفظ...', update: 'تحديث', approveAsCod: 'اعتماد كدفع عند الاستلام', editOrder: 'تعديل الطلب', grandTotal: 'الإجمالي النهائي', orderItems: 'عناصر الطلب', noOrderItems: 'لا توجد عناصر لهذا الطلب.', itemTotal: 'إجمالي العنصر', paymentSummary: 'ملخص الدفع', subtotal: 'المجموع الفرعي', discount: 'الخصم', cardPaymentDiscount: 'خصم الدفع بالبطاقة', active: 'نشط', removedPaymentFailed: 'أُلغي بسبب فشل الدفع', shipping: 'الشحن', customer: 'العميل', guestCustomer: 'عميل ضيف', customerNumber: 'العميل #{number}', noEmail: 'لا يوجد بريد إلكتروني', noPhone: 'لا يوجد رقم هاتف', shippingAddress: 'عنوان الشحن', addressNotProvided: 'العنوان غير متوفر', noShippingAddress: 'لا يوجد عنوان شحن.', orderInformation: 'معلومات الطلب', couponCode: 'رمز الخصم', none: 'لا يوجد', paymentStatus: 'حالة الدفع', trackingNumber: 'رقم التتبع', notAssigned: 'غير معيّن', transactionId: 'معرّف العملية', campaignAttribution: 'مصدر الحملة', source: 'المصدر', medium: 'الوسيط', campaign: 'الحملة', bostaShipment: 'شحنة بوسطة', carrier: 'شركة الشحن', shipmentStatus: 'حالة الشحنة', notAssignedYet: 'لم يُعيّن بعد', deliveredAt: 'تم التسليم في', payout: 'المستحقات', payoutTransaction: 'عملية المستحقات', bostaShipmentError: 'رفضت بوسطة هذه الشحنة', failed: 'فشلت', manualReview: 'تحتاج إلى مراجعة يدوية', sku: 'رمز المنتج',
    orderNumber: 'رقم الطلب', dateCreated: 'تاريخ الإنشاء', shippingPrice: 'سعر الشحن', totalPrice: 'السعر الإجمالي', currency: 'العملة', paymentMethod: 'طريقة الدفع', status: 'الحالة', waybillNumber: 'رقم بوليصة الشحن', searchOrders: 'ابحث بالاسم أو الهاتف أو بوليصة بوسطة...',
    reportingPeriod: 'فترة التقرير', apply: 'تطبيق', bestSellers: 'الأكثر مبيعاً', unitsSold: 'وحدة مباعة', orderStatusBreakdown: 'تفصيل حالات الطلبات', ordersInPeriod: 'طلب في {period}.', approvedValue: 'قيمة الطلبات المعتمدة', outForDeliveryValue: 'قيمة الطلبات الخارجة للتسليم', noSalesInPeriod: 'لا توجد مبيعات لمنتجات تم تسليمها في هذه الفترة.', noOrdersInPeriod: 'لم يتم إنشاء طلبات في هذه الفترة.', loadingReport: 'جارٍ تحميل التقرير…', invalidReportDates: 'يجب أن يكون تاريخ البداية قبل تاريخ النهاية أو مساوياً له.', unableToLoadReport: 'تعذر تحميل تقرير الطلبات.',
    rankedBestSellers: 'مرتبة بحسب الوحدات المباعة من الطلبات المسلّمة في {period}.', allOrdersInPeriod: 'جميع الطلبات التي أُنشئت في {period}.',
  },
};

export function translate(locale, key, replacements = {}) {
  const value = messages[locale]?.[key] ?? messages.en[key] ?? key;

  return Object.entries(replacements).reduce(
    (text, [name, replacement]) => text.replace(`{${name}}`, replacement),
    value,
  );
}

// Legacy screens still contain static text in templates and table definitions. This
// dictionary is deliberately limited to interface copy; API data is never translated.
const legacyArabic = {
  'Monthly Order Report': 'تقرير الطلبات الشهري', 'Order Report': 'تقرير الطلبات', 'Sales performance, order activity, and products customers purchased most.': 'أداء المبيعات ونشاط الطلبات والمنتجات الأكثر شراءً.', 'Sales, order activity, and best sellers for a selected date range.': 'المبيعات ونشاط الطلبات والأكثر مبيعاً خلال فترة محددة.', 'Reporting period': 'فترة التقرير', 'Month': 'الشهر', 'Year': 'السنة', 'Apply': 'تطبيق', 'Best sellers': 'الأكثر مبيعاً', 'Ranked by units sold from delivered orders in the selected month.': 'مرتبة بحسب الوحدات المباعة من الطلبات المسلّمة خلال الشهر المحدد.', 'All orders created in the selected month.': 'جميع الطلبات التي أُنشئت في الشهر المحدد.', 'Order status breakdown': 'تفصيل حالات الطلبات', 'No delivered product sales for this month.': 'لا توجد مبيعات لمنتجات تم تسليمها هذا الشهر.', 'No delivered product sales in this date range.': 'لا توجد مبيعات لمنتجات تم تسليمها في هذه الفترة.', 'No orders were created in this month.': 'لم يتم إنشاء طلبات هذا الشهر.', 'No orders were created in this date range.': 'لم يتم إنشاء طلبات في هذه الفترة.', 'Loading report…': 'جارٍ تحميل التقرير…',
  'Customer delivery details': 'تفاصيل تسليم العميل', 'Update Order': 'تحديث الطلب', 'Create Product': 'إضافة منتج', 'Edit Product': 'تعديل المنتج', 'Product Details': 'تفاصيل المنتج', 'Product Prices': 'أسعار المنتج', 'Option Types': 'أنواع الخيارات', 'Loading...': 'جارٍ التحميل...', 'Loading product details...': 'جارٍ تحميل تفاصيل المنتج...',
  'Please correct the following errors:': 'يرجى تصحيح الأخطاء التالية:', 'Manage fit profiles': 'إدارة ملفات القياس', 'Sizing info shown on the product page.': 'معلومات المقاس المعروضة في صفحة المنتج.', 'Best Seller': 'الأكثر مبيعاً', 'New Arrival': 'وصل حديثاً', 'Show on Homepage': 'عرض في الصفحة الرئيسية', 'Shown in this product\'s category section on the homepage.': 'يظهر في قسم تصنيف المنتج على الصفحة الرئيسية.', 'Special Offer': 'عرض خاص', 'Has Variants?': 'هل له خيارات؟', 'Product Options': 'خيارات المنتج', 'Option Values': 'قيم الخيارات', 'Variant Matrix': 'مصفوفة الخيارات', 'Variant': 'الخيار', 'Active': 'نشط', 'Price': 'السعر',
  'SKU:': 'رمز المنتج:', 'Category:': 'التصنيف:', 'Sub-Category:': 'التصنيف الفرعي:', 'Total Quantity:': 'إجمالي الكمية:', 'Base Price Configuration': 'إعدادات السعر الأساسي', 'Description': 'الوصف', 'Product Variants': 'خيارات المنتج', 'Attributes': 'الخصائص', 'Stock': 'المخزون', 'Main': 'رئيسي', 'No variant images': 'لا توجد صور للخيارات', 'No price': 'لا يوجد سعر', 'Performance & Badges': 'الأداء والشارات', 'Average Rating': 'متوسط التقييم', 'Timestamps': 'التواريخ', 'Created At:': 'تاريخ الإنشاء:', 'Last Updated:': 'آخر تحديث:',
  'Create Product Set Item': 'إضافة عنصر مجموعة منتجات', 'Edit Product Set Item': 'تعديل عنصر مجموعة منتجات', 'View Product Set Item': 'عرض عنصر مجموعة منتجات', 'Product Set Items': 'عناصر مجموعات المنتجات', 'Basic Information': 'المعلومات الأساسية', 'Products Count': 'عدد المنتجات', 'Is Active:': 'نشط:', 'No image': 'لا توجد صورة', 'No products in this set': 'لا توجد منتجات في هذه المجموعة', 'Total Price (Calculated Automatically)': 'السعر الإجمالي محسوب تلقائياً', 'Back to Product Set Items': 'العودة إلى عناصر مجموعات المنتجات', 'Search Products': 'البحث عن المنتجات', 'Type to search products by name or SKU...': 'اكتب للبحث عن المنتجات بالاسم أو رمز المنتج...', 'Filter products to make selection easier': 'صفِّ المنتجات لتسهيل الاختيار', 'Select at least one product for this set': 'اختر منتجاً واحداً على الأقل لهذه المجموعة', 'Selected Products': 'المنتجات المختارة', 'SKU is automatically generated each time you open this form': 'يتم إنشاء رمز المنتج تلقائياً عند فتح النموذج', 'SKU cannot be changed': 'لا يمكن تغيير رمز المنتج',
  'Order': 'الطلب', 'Customer': 'العميل', 'Date': 'التاريخ', 'Total': 'الإجمالي', 'Status': 'الحالة', 'Payment': 'الدفع', 'View': 'عرض', 'Image': 'الصورة', 'Name': 'الاسم', 'Quantity': 'الكمية', 'Actions': 'الإجراءات', 'Products': 'المنتجات', 'Category': 'التصنيف', 'SubCategory': 'التصنيف الفرعي', 'Sub-Category': 'التصنيف الفرعي', 'Created At': 'تاريخ الإنشاء', 'Total Price': 'السعر الإجمالي', 'Discount': 'الخصم', 'Cancel': 'إلغاء', 'None': 'لا يوجد', 'No': 'لا', 'Yes': 'نعم', 'N/A': 'غير متاح',
  'Failed to load order details.': 'تعذر تحميل تفاصيل الطلب.', 'Order and delivery details updated successfully!': 'تم تحديث تفاصيل الطلب والتسليم بنجاح.', 'Failed to create product.': 'تعذر إنشاء المنتج.', 'Product created successfully!': 'تم إنشاء المنتج بنجاح.', 'Failed to load product.': 'تعذر تحميل المنتج.', 'Product updated successfully!': 'تم تحديث المنتج بنجاح.', 'Failed to update product.': 'تعذر تحديث المنتج.', 'Failed to load product details.': 'تعذر تحميل تفاصيل المنتج.', 'Failed to load product set items.': 'تعذر تحميل عناصر مجموعة المنتجات.', 'Failed to load product set item.': 'تعذر تحميل عنصر مجموعة المنتجات.', 'Failed to load product set item details.': 'تعذر تحميل تفاصيل عنصر مجموعة المنتجات.', 'Failed to load products.': 'تعذر تحميل المنتجات.', 'Failed to load categories.': 'تعذر تحميل التصنيفات.',
};

const legacyTextNodes = new WeakMap();

export function localizeLegacyDom(locale, root = document.body) {
  if (!root) return;

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);

  nodes.forEach((node) => {
    const parent = node.parentElement;
    if (!parent || ['SCRIPT', 'STYLE'].includes(parent.tagName)) return;
    const source = legacyTextNodes.get(node) ?? node.nodeValue;
    legacyTextNodes.set(node, source);
    const trimmed = source.trim();
    const translated = locale === 'ar' ? (legacyArabic[trimmed] || trimmed) : trimmed;
    if (trimmed && translated !== trimmed) node.nodeValue = source.replace(trimmed, translated);
    else if (node.nodeValue !== source) node.nodeValue = source;
  });

  root.querySelectorAll('[placeholder], [title], [aria-label]').forEach((element) => {
    ['placeholder', 'title', 'aria-label'].forEach((attribute) => {
      const sourceAttribute = `data-i18n-source-${attribute.replace(/[^a-z]/g, '')}`;
      const source = element.getAttribute(sourceAttribute) ?? element.getAttribute(attribute);
      if (!source) return;
      element.setAttribute(sourceAttribute, source);
      element.setAttribute(attribute, locale === 'ar' ? (legacyArabic[source] || source) : source);
    });
  });
}
